<template>
  <div>
    <div v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.BOOK_WITH_FILE)" class="spl-bwf">
      <subpage-header back-link="dashboard" label="Book with File" />
      <div class="spl-bwf-row">
        <div class="spl-dashboard">
          <input
            id="myFiles"
            ref="myFiles"
            type="file"
            size="50"
            data-cy="book-with-file__file-input"
            @change="verify_Parcels_in_Excel_File">
          <div class="spl-bwf-template">
            <div
              class="spl-info spl-help-tooltip">
              <span class="tooltiptext">Download a template in order to book the parcels.</span>
            </div>
            <form-button
              class="spl-bwf-template-download"
              @onClick="downloadTemplate">
              Download Template
            </form-button>
          </div>
        </div>
      </div>
      <div class="spl-bwf-table">
        <table v-if="!isLoading">
          <thead>
            <tr class="spl-bwf-table__head">
              <th
                v-for="(column, index) in parcelColumns"
                :key="'bookWithFilePreviewHeader' + index"
                class="spl-bwf-table__field">
                {{ column.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(parcel, index) in parcelsPreview"
              :key="'bookWithFilePreviewParcel' + index"
              :class="{'spl-bwf-table__row--valid': parcel.Message_List.length === 0,
                       'spl-bwf-table__row--warning': parcel.warning && !parcel.error,
                       'spl-bwf-table__row--error': parcel.error}">
              <td
                v-for="(column, columnIndex) in parcelColumns"
                :key="'bookWithFilePreviewColumn' + columnIndex"
                :class="{'spl-bwf-table__field--number': isNumber(parcel[column.name]),
                         'spl-bwf-table__field--empty': isEmpty(parcel[column.name]),
                         'spl-bwf-table__field--sticky': column.fixed,
                         'spl-bwf-table__field--long': column.long,
                         'spl-bwf-table__field--bold': column.bold,
                         'spl-bwf-table__field--warning': parcel.messages[column.name] === 'warning',
                         'spl-bwf-table__field--error': parcel.messages[column.name] === 'error'}">
                {{ formatField(parcel.Parcel[column.name], column.name, column.type) }}
                <span v-if="hasMessage(parcel, column)" class="spl-bwf-table__tooltip">{{ getMessage(parcel, column) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Next step footer -->
      <general-footer
        :disable-positive="disableBooking()"
        :positive-label="'Book Parcels'"
        @positiveClicked="book_Parcels_With_Excel_File" />
    </div>
    <message-modal />
    <div v-if="isLoading" class="spl-load-img" />
  </div>
</template>

<script>
import Helpers from '@/helpers'
import webApi from '@/webApi'
import constants from '@/constants'
import { get, find, isNumber, round, includes, map } from 'lodash'

export default {
  name: 'Playground',
  mixins: [Helpers],
  data () {
    return {
      constants,
      parcelsPreview: [],
      responseText: '',
      isLoading: false,
      parcelColumns: [
        { name: constants.REFERENCE_TYPE_NAME.COUNTER_NUMBER, label: 'Counter Number', selected: true, long: true, fixed: true },
        { name: constants.REFERENCE_TYPE_NAME.FORWARDER_REFERENCE, label: 'Forwarder Ref.', selected: true, long: true },
        { name: constants.PARCEL_FIELD_KEYS.CUSTOMER_NAME, label: 'Company', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.COUNTRY_NAME, label: 'Country', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.LATEST_NOTE, label: 'Latest Note', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.CLOSE_DEADLINE, type: 'Time', label: 'Deadline', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.DANGEROUS_GOODS, label: 'DGR', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.XRAYED, label: 'X Rayed', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.Last_Mile_Upgrade, label: 'Last Mile Upgrade', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.SERVICE_LEVEL_NAME, label: 'Service Level', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.DELIVERY_NAME_1, label: 'Delivery Name', selected: true, long: true },
        { name: constants.PARCEL_FIELD_KEYS.DELIVERY_STREET_1, label: 'Delivery Street', selected: true, long: true },
        { name: constants.PARCEL_FIELD_KEYS.DELIVERY_POSTAL_CODE, label: 'Delivery Postal Code', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.DELIVERY_CITY, label: 'Delivery City', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.DELIVERY_COUNTRY_NAME, label: 'Delivery Country', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.PICKUP_NAME_1, label: 'Pickup Name', selected: true, long: true },
        { name: constants.PARCEL_FIELD_KEYS.PICKUP_STREET_1, label: 'Pickup Street', selected: true, long: true },
        { name: constants.PARCEL_FIELD_KEYS.PICKUP_POSTAL_CODE, label: 'Pickup Postal Code', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.PICKUP_CITY, label: 'Pickup City', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.PICKUP_COUNTRY_NAME, label: 'Pickup Country', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.WEIGHT, label: 'Weight', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.VOLUME, label: 'Volume', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.LENGTH, label: 'Length', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.WIDTH, label: 'Width', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.HEIGHT, label: 'Height', selected: true },
        { name: constants.PARCEL_FIELD_KEYS.BOOKED_PICKUP_DATE, type: 'Date', label: 'Pickup Date', selected: true },
        { name: constants.REFERENCE_TYPE_NAME.SHIPMENT_REFERENCE, label: 'Shipment Ref.', selected: true },
        { name: constants.REFERENCE_TYPE_NAME.DELIVERY_NOTE_NUMBER, label: 'Delivery Note', selected: true },
        { name: constants.REFERENCE_TYPE_NAME.ORDER_NUMBER, label: 'Order Nr.', selected: true },
        { name: constants.REFERENCE_TYPE_NAME.SERVICE_ORDER, label: 'Service Order', selected: true },
        { name: constants.REFERENCE_TYPE_NAME.BARCODE, label: 'Barcode', selected: true },
        { name: constants.REFERENCE_TYPE_NAME.CMR_NUMBER, label: 'CMR Nr.', selected: true },
        { name: constants.REFERENCE_TYPE_NAME.PICKUP_REFERENCE, label: 'Pickup Ref.', selected: true },
        { name: constants.REFERENCE_TYPE_NAME.STORAGE_NUMBER, label: 'Storage Nr.', selected: true },
        { name: constants.REFERENCE_TYPE_NAME.CUSTOMS_DECLARATION_NUMBER, label: 'Customs Decl. Nr.', selected: true },
        { name: constants.REFERENCE_TYPE_NAME.CUSTOMER_RETURN_REFERENCE, label: 'Customer Ret. Ref.', selected: true },
        { name: constants.REFERENCE_TYPE_NAME.RETURN_BARCODE, label: 'Return Barcode', selected: true },
        { name: constants.REFERENCE_TYPE_NAME.FORWARDER_RETURN_REFERENCE, label: 'Forwarder Ret. Ref.', selected: true },
        { name: constants.REFERENCE_TYPE_NAME.RETURN_COUNTER_NUMBER, label: 'Ret. Counter Nr.', selected: true }
      ],
      errorColumns: [constants.REFERENCE_TYPE_NAME.COUNTER_NUMBER, constants.PARCEL_FIELD_KEYS.COUNTRY_NAME, constants.PARCEL_FIELD_KEYS.CUSTOMER_NAME]
    }
  },
  methods: {
    verify_Parcels_in_Excel_File () {
      var fileToUpload = this.$refs.myFiles.files[0]
      var formData = new FormData()
      formData.append('file', fileToUpload)
      this.isLoading = true
      webApi.parcel.verify_Parcels_in_Excel_File(formData)
        .then((response) => {
          this.isLoading = false
          // Convert the loaded list into JSON object list
          this.parcelsPreview = response.data
          this.prepareData(response.data)
        }).catch((response) => {
          this.isLoading = false
          window.bus.$emit('openErrorModal', 'Error uploading file: ' + response.data.ExceptionMessage)
        })
    },
    prepareData (parcelList) {
      for (let i = 0; i < parcelList.length; i++) {
        const parcel = parcelList[i].Parcel
        for (const key in constants.REFERENCE_TYPE_NAME) {
          if (Object.prototype.hasOwnProperty.call(constants.REFERENCE_TYPE_NAME, key)) {
            const reference = constants.REFERENCE_TYPE_NAME[key]
            this.resolveReference(parcel, reference)
          }
        }
        const messageList = parcelList[i].Message_List
        for (let j = 0; j < messageList.length; j++) {
          const message = messageList[j]
          if (message.Column_Header === constants.PARCEL_FIELD_KEYS.CUSTOMER_ID) {
            message.Column_Header = constants.PARCEL_FIELD_KEYS.CUSTOMER_NAME
          } else if (message.Column_Header === constants.PARCEL_FIELD_KEYS.COUNTRY_ID) {
            message.Column_Header = constants.PARCEL_FIELD_KEYS.COUNTRY_NAME
          } else if (message.Column_Header === 'Counter_Number') {
            message.Column_Header = constants.REFERENCE_TYPE_NAME.COUNTER_NUMBER
          } else if (message.Column_Header === 'Row') {
            message.Column_Header = constants.REFERENCE_TYPE_NAME.COUNTER_NUMBER
          }
        }
        const messages = parcelList[i].messages = {}
        for (let k = 0; k < this.parcelColumns.length; k++) {
          const column = this.parcelColumns[k]
          const message = find(messageList, { Column_Header: column.name })
          if (message) {
            if (includes(this.errorColumns, message.Column_Header)) {
              messages[column.name] = 'error'
              parcelList[i].error = true
            } else {
              messages[column.name] = 'warning'
              parcelList[i].warning = true
            }
          }
        }
      }
      this.parcelsPreview = parcelList
    },
    // gets the reference from the References Array and puts it flat into the parcel
    resolveReference (parcel, referenceID) {
      const foundReference = find(parcel.References, { Reference_Type: referenceID })
      if (foundReference) {
        parcel[referenceID] = foundReference.Reference_Text
      }
    },
    disableBooking () {
      if (this.parcelsPreview.length > 0) {
        return this.errorFoundInExcel()
      }
      return true
    },
    errorFoundInExcel () {
      for (let p = 0; p < this.parcelsPreview.length; p++) {
        if (this.parcelsPreview[p].error) {
          return true
        }
      }
      return false
    },
    book_Parcels_With_Excel_File () {
      var fileToUpload = this.$refs.myFiles.files[0]
      var formData = new FormData()
      this.isLoading = true
      formData.append('file', fileToUpload)
      webApi.parcel.book_Parcels_With_Excel_File(formData)
        .then((response) => {
          // Convert the loaded list into JSON object list
          this.$toast('Booking successful', constants.defaultToastOptions())
          this.isLoading = false
          const parcelCounterNumbers = map(this.parcelsPreview, 'Parcel.' + constants.REFERENCE_TYPE_NAME.COUNTER_NUMBER)
          this.$router.push('/parcel-list?search=' + parcelCounterNumbers.join('%20'))
        }).catch((response) => {
          this.isLoading = false
          window.bus.$emit('openErrorModal', 'Error uploading file: ' + response.data.ExceptionMessage)
        })
    },
    // Special formatting for fields
    formatField (field, name, type) {
      // Weight & Picked up weight will be rounded to two decimal places then fixed in order to improve readability
      if (name === constants.PARCEL_FIELD_KEYS.WEIGHT) {
        return round(field, 2).toFixed(2)
      } else if (name === constants.PARCEL_FIELD_KEYS.VOLUME) {
        // Volume will be rounded to 3 decimal places
        return round(field, 3).toFixed(3)
      } else if (type === 'Date') {
        return this.formatDate(field, false, 'YYYY-MM-DD')
      } else if (type === 'Time') {
        return this.formatDate(field, true, 'YYYY-MM-DD HH:mm')
      }
      // empty fields will be removed
      if (field == null || field === 0) {
        return ''
      }
      return field
    },
    // including of helper since lodash not available in vue template
    isNumber (value) {
      return isNumber(value)
    },
    // helper for removing 0 elements
    isEmpty (value) {
      return value === 0
    },
    getMessage (parcel, column) {
      return get(find(parcel.Message_List, { Column_Header: column.name }), 'Message')
    },
    hasMessage (parcel, column) {
      return this.getMessage(parcel, column) != null
    },
    downloadTemplate () {
      webApi.document.download_Book_With_File_Template()
        .then((result) => {
          this.downloadFile(result, 'Book_With_File_Template.xlsx')
        }).catch((error) => {
          window.bus.$emit('openErrorModal', error.data.ExceptionMessage)
        })
    }
  }
}
</script>
<style lang="scss">
  @import '../variables.scss';
  .spl-bwf {
     background-color: $tableRowBackgroundColorSelected;
     height: calc(100vh);

     .spl-general-footer {
       margin-left: 0px;
     }
  }
  .spl-bwf-template {
    float: right;
  }
  .spl-bwf-row {
    margin: 10px 70px;
  }
  .spl-bwf-template-download {
    margin: 0 0 15px 0;
  }
  .spl-bwf-table {
    margin: 0 70px;
    overflow: auto;
    width: calc(100% - 138px);
    height: calc(100vh - 230px);

    table {
      border-spacing: 0;
      // table-layout: fixed;
    }
    &__head {
      th {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.1);
      }
      &--sticky {
        position: sticky;
        left: 41px;
        z-index: 3 !important;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 10px 2px 0 6px;
        }
        position: sticky;
        left: 0px;
        z-index: 3 !important;
      }
    }
    &__row {
      &--valid td {
        background-color: $successGreenBackground;
      }
      &--warning td {
        background-color: $warningOrangeBackground;
      }
      &--error td {
        background-color: $errorRedBackground;
      }
    }
    &__tooltip {
      display: none;
      position: absolute;
      background-color: $tableHeaderBackgroundColor;
      border: 1px solid $tableRowBorderColor;
      bottom: 20px;
      left: 40px;
      overflow: visible;
      color: black;
      z-index: 5;
      padding: 5px;
    }
    &__field {
      &--number {
        text-align: right;
        width: 70px;
      }
      &--sticky {
        position: sticky;
        left: 0px;
        box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.2);
        background-color: $tableHeaderBackgroundColor;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 0 2px 0 6px;
        }
        position: sticky;
        background-color: $tableHeaderBackgroundColor;
        left: 0;
      }
      &--long {
        max-width: 300px !important;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &--success {
        border-bottom: 2px solid $green !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $green;
      }
      &--warning {
        border-bottom: 2px solid $darkYellow !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $darkYellow;
      }
      &--error {
        border-bottom: 2px solid $red !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $red;
      }
      &--bold {
        font-weight: 600;
      }
      &--empty:hover {
        background-color: $tableRowBackgroundColorHover !important;
      }
    }
    thead {
      th {
        position: sticky;
        top: 0;
        text-align: left;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 12px;
        background-color: $tableHeaderBackgroundColor;
        padding: 0px 5px  0px 5px;
        height: 40px;
        z-index: 2;
        border-bottom: 1px solid $tableHeaderBorderColor;
      }

      th:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }
    }
    tbody {

      tr {
        background-color: $tableRowBackgroundColor;
      }

      tr:hover {
        background-color: $tableRowBackgroundColorHover;
      }

      td {
        border-style: solid;
        border-width: 0 1px 1px 0;
        border-color: $tableRowBorderLowColor;
        border-bottom-color: $tableRowBorderColor;
        font-size: 12px;
        padding: 5px;
        position: relative;
        padding-top: 8px;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 150px;
        &:hover > span.spl-bwf-table__tooltip {
          display: block;
        }
      }

      td:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }

      td:first-child {
        border-left-width: 1px;
      }
    }

  }
</style>
